/**
 * Clean up Google Ads internal naming conventions for display.
 *
 * Restaurant: "AAA_Luminarias (1000)" → "Luminarias"
 * Campaign:   "The Rusty Pelican Miami - Restaurant" → stays as-is (already clean)
 * Ad Group:   "Private Events - EXACT w/ Limited BROAD - forceBROADnegs" → "Private Events"
 *             "ZZZ_Christmas Experience - EXACT w/ Limited Broad" → "Christmas Experience (Paused)"
 *             "TEMP Branded - EXACT" → "Branded (Temp)"
 */

export function normalizeRestaurantName(name: string): string {
  // Strip "AAA_" prefix
  let clean = name.replace(/^AAA_/, '');
  // Strip trailing " (1000)" budget markers
  clean = clean.replace(/\s*\(\d+\)\s*$/, '');
  return clean.trim();
}

export function normalizeAdGroupName(name: string): string {
  let clean = name;

  // Detect paused (ZZZ_ prefix)
  const isPaused = /^ZZZ[_ ]/i.test(clean);
  clean = clean.replace(/^ZZZ[_ ]*/i, '');

  // Detect temp
  const isTemp = /^TEMP[_ ]*/i.test(clean);
  clean = clean.replace(/^TEMP[_ ]*/i, '');

  // Strip match type suffixes:
  // " - EXACT w/ Limited BROAD - forceBROADnegs"
  // " - EXACT w/ 1 BROAD - forceBROADnegs"
  // " - EXACT"
  clean = clean.replace(/\s*-\s*(EXACT|BROAD|PHRASE).*$/i, '');

  // Strip " - forceBROADnegs" if standalone
  clean = clean.replace(/\s*-\s*forceBROADnegs\s*/gi, '');

  // Strip parenthetical date hints like "(End 11/26/25)"
  clean = clean.replace(/\s*\(End\s+\d{1,2}\/\d{1,2}\/\d{2,4}\)\s*/gi, '');

  clean = clean.trim();

  // Add suffix tags
  if (isPaused && isTemp) clean += ' (Paused)';
  else if (isPaused) clean += ' (Paused)';
  else if (isTemp) clean += ' (Temp)';

  return clean;
}

export function normalizeCampaignName(name: string): string {
  // Campaigns are already mostly clean, just strip "AAA_" if present
  return name.replace(/^AAA_/, '').trim();
}
